import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Config } from '../../components';
import { LogisticCompany } from '../../contracts';
import { ErrorHandler } from '../../util';
import { getAllLogisticCompaniesQuery } from './Queries/GetAllLogisticCompaniesQuery';

export class LogisticCompanyApolloClient {

  private apolloClient: ApolloClient<NormalizedCacheObject>;

  constructor(identityToken: string, config: Config) {
    const httpLink = createHttpLink({
      uri: config.webAPIConfig.graphQlHttpApiUrl,
    });

    const authLink = setContext((_, { headers }) => ({
      headers: {
        ...headers,
        authorization: identityToken ? `Bearer ${identityToken}` : '',
      },
    }));

    this.apolloClient = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });
  }

  public async getAllLogisticCompanies(): Promise<Array<LogisticCompany>> {
    try {
      const queryResult = await this.apolloClient.query({
        query: getAllLogisticCompaniesQuery,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
      });

      return queryResult.data.logisticCompanies;
    } catch (error) {
      ErrorHandler.handleError(error);
      return [];
    }
  }
}
